import React from "react";
import { Box } from "@mui/material";

/** Select value rendered as "Label: Value" so each filter is self-describing. */
const FilterSelectValue = ({ label, value }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      minWidth: 0,
      maxWidth: "100%",
    }}
  >
    <Box component="span" sx={{ color: "#64748b", fontWeight: 500, flexShrink: 0 }}>
      {label}:
    </Box>
    <Box
      component="span"
      sx={{
        color: "#111827",
        fontWeight: 600,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {value}
    </Box>
  </Box>
);

export default FilterSelectValue;
